"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntitlementSchema = exports.ENTITLEMENT_SOURCES = exports.ENTITLEMENT_STATES = void 0;
exports.entitlementSortKey = entitlementSortKey;
exports.computeEntitlements = computeEntitlements;
exports.derivedEnabledPackages = derivedEnabledPackages;
const zod_1 = require("zod");
/**
 * ENTITLEMENTS — the only surface feature code reads to answer
 * "may this tenant do X, at this location?".
 */
exports.ENTITLEMENT_STATES = ['active', 'grace', 'suspended', 'cancelled', 'pending_approval'];
exports.ENTITLEMENT_SOURCES = ['subscription', 'trial', 'admin_grant', 'comp', 'included'];
exports.EntitlementSchema = zod_1.z.object({
    tenantId: zod_1.z.string().min(1),
    skuId: zod_1.z.string().min(1),
    packageId: zod_1.z.string().optional(),
    locationId: zod_1.z.string().optional(),
    features: zod_1.z.array(zod_1.z.string()).default([]),
    state: zod_1.z.enum(exports.ENTITLEMENT_STATES),
    source: zod_1.z.enum(exports.ENTITLEMENT_SOURCES),
    activatedAt: zod_1.z.number(),
    expiresAt: zod_1.z.number().optional(),
    suspendedAt: zod_1.z.number().optional(),
    subscriptionItemId: zod_1.z.string().optional(),
});
/** Sort key for an entitlement row: tenant-scoped or location-scoped. */
function entitlementSortKey(skuId, locationId) {
    return locationId ? `LOC#${locationId}#${skuId}` : `TENANT#${skuId}`;
}
const STATE_RANK = {
    active: 0, grace: 1, pending_approval: 2, suspended: 3, cancelled: 4,
};
/**
 * `collections_only` (device financing) NEVER removes access — an unpaid
 * terminal must keep working; arrears escalate to collections instead.
 */
function stateFor(item, sku) {
    if (item.paymentState === 'cancelled')
        return 'cancelled';
    if (item.paymentState === 'active')
        return 'active';
    if (sku.enforcement === 'collections_only')
        return 'active';
    return item.paymentState === 'grace' ? 'grace' : 'suspended';
}
function computeEntitlements(input) {
    const byKey = new Map();
    for (const item of input.items) {
        const sku = input.skus[item.skuId];
        if (!sku)
            continue; // unknown SKU: skip, never crash
        if (item.startsOn > input.now)
            continue; // not started
        if (item.endsOn !== undefined && item.endsOn <= input.now)
            continue; // term ended
        const locationId = sku.scope === 'location' ? item.locationId : undefined;
        const key = entitlementSortKey(sku.skuId, locationId);
        const candidate = {
            tenantId: input.tenantId,
            skuId: sku.skuId,
            packageId: sku.packageId,
            locationId,
            features: input.featuresBySku[sku.skuId] ?? [],
            state: stateFor(item, sku),
            source: item.source,
            activatedAt: item.startsOn,
            expiresAt: item.endsOn,
            subscriptionItemId: item.subscriptionItemId,
        };
        const existing = byKey.get(key);
        if (!existing || STATE_RANK[candidate.state] < STATE_RANK[existing.state]) {
            byKey.set(key, candidate);
        }
    }
    return [...byKey.values()];
}
/** Derived mirror of the legacy tenant.enabledPackages array. */
function derivedEnabledPackages(ents) {
    const set = new Set();
    for (const e of ents) {
        if ((e.state === 'active' || e.state === 'grace') && e.packageId)
            set.add(e.packageId);
    }
    return [...set];
}
//# sourceMappingURL=billingEntitlements.js.map